import React, { FC } from 'react';
import { Grid } from '@inplayer-org/inplayer-ui';
import styled from 'styled-components';

// constants
import { LiveLikeChatContentFilter } from 'ducks/merchantDucks/items/actions';

// components
import ModerationHeader from './ModerationHeader';
import ModerationRadioField from './ModerationRadioField';

const { Cell, Container } = Grid;

const MarginedContainer = styled(Container)`
  margin-top: 2em;
`;

const ModerationTooltipMessages = {
  FILTERED: `Chat messages will be filtered
    automatically based on their content.
    If a message is detected to contain
    profanity it will be filtered.`,
  NONE: `Every chat message sent in the
  chat will be shown to everyone.`,
};

const Moderation: FC = () => (
  <MarginedContainer columns={1}>
    <Cell>
      <ModerationHeader />
      <ModerationRadioField
        tag="radiobutton_moderation-automatic"
        value={LiveLikeChatContentFilter.FILTERED}
        label="Automatic AI moderation"
        tooltip={ModerationTooltipMessages.FILTERED}
      />
      <ModerationRadioField
        tag="radiobutton_moderation-none"
        value={LiveLikeChatContentFilter.NONE}
        label="None"
        tooltip={ModerationTooltipMessages.NONE}
      />
    </Cell>
  </MarginedContainer>
);

export default Moderation;
